
export enum DynamicPriceApiNameCd {
	BULK_UPDATE_DYNAMIC_PRICING_RULE_BY_TYPE = 'BulkUpdateDynamicPricingRuleByType',
	CREATE_DYNAMIC_PRICING_RULE_HEADER = 'CreateDynamicPricingRuleHeader',
	EXECUTE_DYNAMIC_PRICING_RULE_HEADER = 'ExecuteDynamicPricingRuleHeader',
	GET_RATE_REQUEST_DYNAMIC_PRICING_RULE = 'GetRateRequestDynamicPricingRule',
	UPDATE_DYNAMIC_PRICING_RULE_HEADER = 'UpdateDynamicPricingRuleHeader'}

